import React from 'react';
import { systemText } from '../../helpers/string';

import './paging.css';

const Paging = props => {
	const { page, recordCount, goToPage, narrow, size, bullets } = props;
	const pageSize = props.pageSize || 10;
	const maxPages = narrow ? 5 : 10;
	const pageCount = Math.ceil(recordCount / pageSize);
	const pages = new Array(isNaN(pageCount) ? 0 : pageCount).fill(0);
	const buttonClass = props.className ? props.className : 'btn-default';

	let max = page + 2;
	let min = page - 2;
	if (min <= 1) {
		min = 1;
		max = 5;
	}

	if (min === 2) {
		max = 6;
	}

	if (max >= pageCount) {
		max = pageCount;
		min = pageCount - 4;
	}

	if (max === pageCount - 1) {
		max = pageCount;
		min = pageCount - 4;
	}

	if (narrow) {
		min = page;
		max = page;
	}

	const skipPage = p => {
		if (narrow) {
			if (p === page) return false;
			if (p + 1 === page) return false;
			if (p - 1 === page) return false;
			return true;
		}

		if (pageCount < maxPages) return false;
		if (p === 1 || p === pageCount) return false;
		if (p >= min && p <= max) return false;
		return true;
	};

	let showsPageOnLast = true;

	return (
		<nav data-testid={props.id ? `paging-${props.id}` : undefined}>
			<ul className={`pagination ${bullets ? 'flex flex-center bullets' : ''}`}>
				<li className="page-item">
					<button
						className={`paging-prev btn btn-${size || 'sm'} ${page === 1 ? '' : buttonClass}`}
						onClick={() => goToPage(page - 1)}
						disabled={page === 1 || pageCount === 0 ? 'disabled' : ''}
						aria-label="Previous Page"
						data-testid="paging-prev"
					>
						<i className={`fa fa-arrow-left ${narrow ? '' : 'mr10'}`} />
						{!narrow && <span>{systemText('General/Paging/Prev')}</span>}
					</button>
				</li>
				{pages.map((p, i) => {
					const skipping = !bullets && skipPage(i + 1);
					if (skipping && showsPageOnLast) {
						showsPageOnLast = false;
						return (
							<li key={i} className="page-item hidden-xs">
								<button className={`btn btn-${size || 'sm'} disabled ellipse`}>...</button>
							</li>
						);
					}

					if (skipping) return null;

					showsPageOnLast = true;

					return (
						<li key={i} className="page-item hidden-xs">
							{i + 1 === page ? (
								<button
									className={`paging-page btn btn-primary btn-${size || 'sm'}`}
									disabled="disabled"
									data-testid={`paging-${i + 1}`}
									aria-label={`Goto page ${i + 1}`}
								>
									<strong>{i + 1}</strong>
								</button>
							) : (
								<button
									className={`paging-page btn btn-${size || 'sm'} ${buttonClass}`}
									onClick={() => goToPage(i + 1)}
									data-testid={`paging-${i + 1}`}
									aria-label={`Goto page ${i + 1}`}
								>
									{i + 1}
								</button>
							)}
						</li>
					);
				})}
				<li className="page-item">
					<button
						className={`paging-next btn btn-${size || 'sm'} ${
							page === pageCount || pageCount === 0 ? '' : buttonClass
						}`}
						onClick={() => goToPage(page + 1)}
						disabled={page === pageCount || pageCount === 0 ? 'disabled' : ''}
						data-testid="paging-next"
						aria-label="Next Page"
					>
						{!narrow && <span>{systemText('General/Paging/Next')}</span>}
						<i className={`fa fa-arrow-right ${narrow ? '' : 'ml10'}`} />
					</button>
				</li>
			</ul>
		</nav>
	);
};

export default Paging;
